import { render, staticRenderFns } from "./ThumbsUpDown.vue?vue&type=template&id=c381e4fe&scoped=true&"
import script from "./ThumbsUpDown.vue?vue&type=script&lang=js&"
export * from "./ThumbsUpDown.vue?vue&type=script&lang=js&"
import style0 from "./ThumbsUpDown.vue?vue&type=style&index=0&id=c381e4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c381e4fe",
  null
  
)

export default component.exports